import {Box} from "@mui/material";
import React from "react";

export const TableItem = ({data}) => {
  return (
    <div className="table__tr">
      <Box sx={{ flex: "1 0 68px" }} className="table__td">
        <p className="table__text">{data.date}</p>
      </Box>
      <Box sx={{ flex: "1 0 68px" }} className="table__td">
        <p className="table__text">{data.visitors}</p>
      </Box>
      <Box sx={{ flex: "1 0 68px" }} className="table__td">
        <p className="table__text">{data.registrations}</p>
      </Box>
      <Box sx={{ flex: "1 0 68px" }} className="table__td">
        <p className="table__text">{data.active_users}</p>
      </Box>
      <Box sx={{ flex: "1 0 68px" }} className="table__td">
        <p className="table__text">{data.ctr}</p>
      </Box>
      <Box sx={{ flex: "1 0 67px" }} className="table__td">
        <p className="table__text">{data.ftd}</p>
      </Box>
      <Box sx={{ flex: "1 0 78px" }} className="table__td">
        <p className="table__text">{data.ftds}</p>
      </Box>
      <Box sx={{ flex: "1 0 70px" }} className="table__td">
        <p className="table__text">{data.dpst}</p>
      </Box>
      <Box sx={{ flex: "1 0 64px" }} className="table__td">
        <p className="table__text">{data.dpsts}</p>
      </Box>
      <Box sx={{ flex: "1 0 85px" }} className="table__td">
        <p className="table__text">{data.rvn}</p>
      </Box>
      <Box sx={{ flex: "1 0 100px" }} className="table__td">
        <p className="table__text">{data.rvns}</p>
      </Box>
    </div>
  )
}